
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes04 as ObiDiodes04Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-04.js';
 
 
 

 
 export const ObiDiodes04 = createComponent({
   react: React,
   tagName: 'obi-diodes-04',
   elementClass: ObiDiodes04Element,
   events: {
     
   }
  });
 
 